<template>
	<div>
		<v-row>
			<v-col cols="6" class="d-flex align-center">
				<v-select
					v-model="idBandoSelezionato"
					:items="bandi"
					item-text="nome"
					item-value="id"
					label="Bando selezionato"
					:loading="isLoadingBandi"
					:disabled="isLoadingBandi"
					outlined
					dense
					hide-details
					class="mr-2"
				></v-select>
				<v-btn
					color="secondary"
					@click="impostaBando()"
					:loading="isSettingBando"
					:disabled="isLoadingBandi"
				>
					Seleziona bando
				</v-btn>
			</v-col>
		</v-row>
		
		<template v-if="isAccountManager && [1, 4, 5, 6].includes(user.account_manager?.id)">
			<div class="mt-10 font-weight-bold">DESCRIZIONI FASI E STATI</div>
			<v-row>
				<v-col>
					<v-expansion-panels accordion multiple eager>
						<v-expansion-panel
							v-for="(fase, index) in fasiWithStatiToEdit"
							:key="index"
						>
							<v-expansion-panel-header class="primary tertiary--text font-weight-medium">
								Fase {{ fase.ordinamento }}: {{ strutturaDatiPratica.fasi[fase.ordinamento].nome }}
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row class="mt-3">
									<v-col>
										<v-sheet
											rounded
											color="primary"
											class="px-3 py-1 mb-2 white--text"
										>
											Descrizione Fase
										</v-sheet>
										<editor :editor-id="`fase-${fase.id}`" v-model="fase.descrizione"></editor>
									</v-col>
									<v-col>
										<v-sheet
											rounded
											color="primary"
											class="px-3 py-1 mb-2 white--text"
										>
											Anteprima
										</v-sheet>
										<div v-html="fase.descrizione"></div>
									</v-col>
								</v-row>
								<template v-for="stato in fase.stati">
									<v-row>
										<v-col>
											<v-sheet
												rounded
												color="primary"
												class="px-3 py-1 mb-2 white--text"
											>
												Descrizione Stato: {{ stato.nome }}
											</v-sheet>
											<editor v-model="stato.descrizione"></editor>
										</v-col>
										<v-col>
											<v-sheet
												rounded
												color="primary"
												class="px-3 py-1 mb-2 white--text"
											>
												Anteprima
											</v-sheet>
											<div v-html="stato.descrizione"></div>
										</v-col>
									</v-row>
								</template>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
			</v-row>
			
			<div class="d-flex justify-end">
				<v-btn
					large
					color="secondary"
					@click="salvaDescrizioniFasiEStati()"
					:loading="isSaving"
					class="mt-2"
				>
					Salva descrizioni
				</v-btn>
			</div>
		</template>
		
		<template v-if="isAccountManager">
			<div class="mt-10 mb-2 font-weight-bold">FRASI E LINK FASE PUBBLICAZIONE ESITO</div>
			<v-row>
				<v-col>
					<v-textarea
						label="Frase Del Link Pubblicazione Esiti Provvisori"
						outlined
						class="mt-1"
						v-model="fraseDelLinkPubblicazioneEsitiProvvisori"
					></v-textarea>
				
					<v-textarea
						label="Frase Del Link Pubblicazione Esiti Definitivi"
						outlined
						class="mt-1"
						v-model="fraseDelLinkPubblicazioneEsitiDefinitivi"
					></v-textarea>
				
					<v-text-field
						label="Link Pubblicazione Esiti Provvisori"
						outlined
						class="mt-1"
						v-model="linkPubblicazioneEsitiProvvisori"
					></v-text-field>
				
					<v-text-field
						label="Link Pubblicazione Esiti Definitivi"
						outlined
						class="mt-1"
						v-model="linkPubblicazioneEsitiDefinitivi"
						hide-details
					></v-text-field>
				
					<div class="d-flex justify-end">
						<v-btn
							large
							color="secondary"
							@click="aggiornaFrasiELinksPubblicazioneEsiti()"
							:loading="aggiornamentoFrasiELinksPubblicazioneEsiti"
							class="mt-2"
						>
							Salva frasi e links
						</v-btn>
					</div>
				
				
					<!--<pre>{{ bando }}</pre>-->
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
	data() {
		return {
			fabThemeColors: false,
			isSaving: false,
			fasiWithStatiToEdit: [],
			
			isLoadingBandi: false,
			bandi: [],
			idBandoSelezionato: null,
			isSettingBando: false,
			
			fraseDelLinkPubblicazioneEsitiProvvisori: null,
			fraseDelLinkPubblicazioneEsitiDefinitivi: null,
			linkPubblicazioneEsitiProvvisori: null,
			linkPubblicazioneEsitiDefinitivi: null,
			aggiornamentoFrasiELinksPubblicazioneEsiti: false
		}
	},
	
	watch: {
		fasiWithStati(val) {
			this.fasiWithStatiToEdit = JSON.parse(JSON.stringify(val));
		}
	},
	
	created() {
		this.fasiWithStatiToEdit = JSON.parse(JSON.stringify(this.fasiWithStati));
		
		this.fraseDelLinkPubblicazioneEsitiProvvisori = JSON.parse(JSON.stringify(this.bando.frase_del_link_pubblicazione_esiti_provvisori));
		this.fraseDelLinkPubblicazioneEsitiDefinitivi = JSON.parse(JSON.stringify(this.bando.frase_del_link_pubblicazione_esiti_definitivi));
		this.linkPubblicazioneEsitiProvvisori = JSON.parse(JSON.stringify(this.bando.link_pubblicazione_esiti_provvisori));
		this.linkPubblicazioneEsitiDefinitivi = JSON.parse(JSON.stringify(this.bando.link_pubblicazione_esiti_definitivi));
		
		this.getBandi();
		this.idBandoSelezionato = this.bando?.id;
	},
	
	mounted() {
		// console.log(this.$refs)
		
		// document.addEventListener('keypress', (
		// 	function(event){
		// 		if (event.which == '13') {
		// 			event.preventDefault();
		// 			console.log('prevent enter')
		// 		}
		// 	}));
		
		// setTimeout(() => {
		// 	let tipTapEditors = document.getElementsByClassName('el-tiptap-editor');
		// 	console.log(tipTapEditors);
		// }, 4000)
		
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			fasiWithStati: 'fasi/fasiWithStati',
			strutturaDatiPratica: "fasi/strutturaDatiPratica",
			bando: 'shared/bando',
			user: 'auth/user'
		}),
	},
	
	methods: {
		...mapMutations({
			setFasiWithStati: 'fasi/SET_FASI_WITH_STATI'
		}),
		...mapActions({
			showSnackbar: 'systemSnackbar/show',
			getGlobalVariables: 'shared/globalVariables'
		}),
		getBandi() {
			this.isLoadingBandi = true;
			axios.get('/api/bandi')
				.then(response => {
					this.bandi = response.data;
				})
				.finally(() => {
					this.isLoadingBandi = false;
				})
		},
		impostaBando() {
			this.isSettingBando = true;
			axios.post('/api/utenti/imposta-bando', {
				bando_id: this.idBandoSelezionato
			})
				.then(() => {
					location.reload();
				})
				.finally(() => {
					this.isSettingBando = false;
				})
		},
		salvaDescrizioniFasiEStati() {
			this.isSaving = true;
			axios.patch('/api/fasi/with-stati', this.fasiWithStatiToEdit)
				.then(() => {
					this.setFasiWithStati(this.fasiWithStatiToEdit);
					
					this.showSnackbar({
						color: 'success',
						message: 'Salvataggio riuscito'
					})
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		aggiornaFrasiELinksPubblicazioneEsiti() {
			this.aggiornamentoFrasiELinksPubblicazioneEsiti = true;
			axios.post('/api/bandi/aggiorna-frasi-e-links-pubblicazione-esiti', {
				bando_id: this.bando.id,
				frase_del_link_pubblicazione_esiti_provvisori: this.fraseDelLinkPubblicazioneEsitiProvvisori,
				frase_del_link_pubblicazione_esiti_definitivi: this.fraseDelLinkPubblicazioneEsitiDefinitivi,
				link_pubblicazione_esiti_provvisori: this.linkPubblicazioneEsitiProvvisori,
				link_pubblicazione_esiti_definitivi: this.linkPubblicazioneEsitiDefinitivi
			})
				.then(() => {
					this.getGlobalVariables()
				})
				.finally(() => {
					this.aggiornamentoFrasiELinksPubblicazioneEsiti = false;
				})
		}
	}
}
</script>